// Wizard Update Rates

function layout() {
  const ctxView = {
    selectable: false, // options: multi - one - false
    domain: [],
    model: "hotel.calendar.line",
    fields: {
      accommodation: {
        model: "product.product",
        type: "many2one",
        readOnly: true,
      },
      price_list: {
        model: "product.price_list",
        type: "many2one",
        readOnly: true,
      },
      unit_price: { type: "numeric" },
    },
    list: [
      { name: "accommodation", width: "40%" },
      { name: "price_list", width: "40%" },
      { name: "unit_price", width: "20%", editable: true },
    ],
    form: [],
  };

  return ctxView;
}

export { layout };
